import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from '../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from '../../../../shared/util/util';
import Multiselect from 'vue-multiselect'
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import BookingService from '../../../../cargobooking/services/cargobooking.service';
import ClientService from '../../../../clientmanagement/services/clientmanagement.service';
import draggable from 'vuedraggable';
import xlsx from "xlsx";
const moment = require('moment');

export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
	Multiselect,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
    TripServices,
	draggable
  },
  props: ['selectedEditRowData'],
  data: function () {
	return {
		isLoading: false,
		filename: "",
		val: 0,
		progress: 0,
		client: null,
		clientid: '',
		businessaccountname: '',
		clientbusinessdetailid: '',
		clientbusinessaccountid: '',
		SKUData: [],
		SKUlist: [],
		ClientUOM: "",
		activecontract: "",
		totalRecords: 0,
		successRecords: 0,
		failedRecords: {},
		showresult: false,
		disabled: false,
		FailedResultModal: false,
		disableclientselection: false,
		compNameArr: [],
		uomArr: [],
		manifestMethods: [],
		boxtypelist: [],
		clientFileType: 3,
		filesource: "../static/Sample_TripRoute_Data.xlsx",
		showuploadresult: false,
		uploadResultData: [],
		importResultData: [],
		showimportbutton: false,
		showimportresult: false,
		batchsizeforimport: 0,
		validrecordsforimport: 0,
		Clientlist: [],
		userName: "",
		fileid: 0,
		file: null,
		stepOne: false,
		stepTwo: false,
		stepThree: false,
		progressarr: ['stop', 'stop', 'stop', 'stop'],
		totaldata: 0,
		validateddata: 0,
		validdateddatalist: [],
		limit: 10,
		showprogress: false,
		isEditing: false,
		showSpinner: false,
		clientErr: false,
		disableimport: false,
		offset: 0,
		accordianTab: { 1: false },
		expanded: false,
		tableColumn: ['ID','File Name', 'Created by', 'Created Date', 'Import Status', 'Action'],
		tableItems: [],
		uploadedFileData: [],
		totalUploadRecords:0,
		uploadsuccessRecords:0,
		uploadfailedRecords:{},
		showViewUploadResult:false,
		viewuploadResultData: [],
		showviewuploadresult:false,
		userRoleFlag: 0,
		defaultHubID: '',
		showError:false
	}
},
beforeMount() {
	window.addEventListener("beforeunload", this.preventNavigation)
	this.$once("hook:beforeDestroy", () => {
	  window.removeEventListener("beforeunload", this.this.preventNavigation);
	})
  },

  beforeRouteLeave(to, from, next) {
	if (this.isEditing) {
	  if (!window.confirm("Leave without saving?")) {
		return;
	  }
	}
	next();
  },
  async beforeDestroy() {
	this.isEditing= false;
},
computed: {

},
mounted() {
	var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
	var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
	var plaintext = bytes.toString(CryptoJS.enc.Utf8);
	var userdetail = JSON.parse(plaintext);
	this.userName = userdetail.email;
	this.defaultHubID = userdetail.hubID;
	this.userRoleFlag = (userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Cargo Controlling Tower") ? 1:2;
	// this.progressBar()
	this.getFileUploaddata()
},
methods: {
	preventNavigation(event) {
		if (!this.isEditing) return
		event.preventDefault()
		event.returnValue = ""
	  },
	  toggleCheck(tabid) {
		this.expanded = false;
		for (var key in this.accordianTab) {
		  if (tabid != key) {
			this.accordianTab[key] = false;
		  }
		}
	  },
	async uploadBookingData(e) {
		if (!/\.(xls|xlsx)$/.test(e.target.files[0].name.toLowerCase())) {
			this.isLoading = false;
			this.$refs.files.value=null;
			return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
		}
		this.filename = e.target.files[0].name;
		this.showprogress = true;
		const files = e.target.files;
		this.file = e.target.files[0]

		this.isLoading = false;
		// var reader = new FileReader()
		// reader.readAsDataURL(e.target.files[0])
		// let binaryfile = ''
		// reader.onload = async () => {
		//     binaryfile = reader.result
		//     let result = await this.singleUpload(files[0], 'BookingSoftUpload', reader.result)
		//     this.isLoading = false;
		//     console.log("result => ", result)

		// };
		// console.log(binaryfile);
	},
	async uploadFile(file) {
		try {
			let formData = new FormData();
			formData.append('file', file);
			formData.append('lastmodifiedby', this.userName);
			let result = await TripServices.uploadAutoAllocationFile(formData);
			if (result.data.code == 200) {
				this.fileid = result.data.data.fileid
				this.totaldata = result.data.data.totaldata;
				return true
			} else {
				this.$set(this.progressarr, 0 , 'stop')
				this.showSpinner=false;
				this.showError=true;
				this.$alert(result.data.message, "", "error");
				return false
			}
		} catch (err) {
			this.$set(this.progressarr, 0 , 'stop')
			this.showSpinner=false;
			this.showError=true;
			this.$alert("Internal server error. Please try again.", "", "error");
			console.log(err);
		}
	},
	async validate(fileid) {
		try {
			let input = {
				logfileid: fileid,
				lastmodifiedby: this.userName,
			}
			if (this.userRoleFlag==2) {
				input.hubid = this.defaultHubID[0]
			}
			let result = await TripServices.validateAutoAllocation(input)
			if (result.data.code == 200) {
				this.validdateddatalist.push(...result.data.data)
				this.getFileUploaddata()
				return result.data.data;
			} else {

			}
		} catch (err) {
			console.log(err);
		}
	},
	groupBy(array, property) {
		var hash = {};
		for (var i = 0; i < array.length; i++) {
			if (!hash[array[i][property]]) hash[array[i][property]] = [];
			hash[array[i][property]].push(array[i]);
		}
		return hash;
	},
	openUploadResultData(type) {
		this.showuploadresult = true;
		this.uploadResultData = null;
		this.showimportbutton = false;
		if (type == 'valid') {
			this.uploadResultData = this.successRecords;
			this.showimportresult = false;
			if (this.successRecords.length > 0 || this.importResultData.length != this.successRecords.length) {
				this.showimportbutton = true;
			}
		} else if (type == 'invalid') {
			this.showimportresult = false;
			this.showimportbutton = false;
			this.uploadResultData = this.failedRecords;
		}
	},
	async importValidRecords() {
		try{
			this.$set(this.progressarr, 2 , 'start')
			this.showSpinner=true;
			this.disableimport=true;
			let input = {
				logfileid: this.fileid
			}
			let result = await TripServices.pushValidAutoAllocation(input);
			if (result.data.code == 200) {
				this.$set(this.progressarr, 2 , 'complete')
				this.$set(this.progressarr, 3 , 'complete')
				this.isEditing = false;
				this.disableimport = true;
				this.showSpinner=false;
				this.$alert(result.data.message, "", "success");
			} else {
				this.$alert(result.data.message, "", "error");
			}
			this.getFileUploaddata()
		} catch ( err){
			console.log(err);
		}
	},
	downloadFile() {
		try {
			let downloadArr = [];
			if (this.uploadResultData) {
				downloadArr = this.uploadResultData.map((el) => {
					return {
						"Branch/hub name": el.hubname,
						"Branch/hub id": el.hubid,
						"Route Name": el.routename,
						"Client ID": el.clientid,
						"Client Name": el.clientname,
						"FM Pincodes": el.fmpincode,
						"LM Pincodes": el.lmpincode,
						"Message": el.comment,
					}
				});
				var filename='InvalidRecords.xlsx';
				var ws = xlsx.utils.json_to_sheet(downloadArr);
				var wb = xlsx.utils.book_new();
				xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
				xlsx.writeFile(wb,filename);
			} else {
				const data = xlsx.utils.json_to_sheet(downloadArr);
				const wb = xlsx.utils.book_new();
				xlsx.utils.book_append_sheet(wb, data, 'data')
				xlsx.writeFile(wb, 'InvalidRecords.xlsx');
			}
		} catch (err) {
			console.log(err);
		}
	},
	async selectClient(data) {
		this.resetform();
		if (data) {
			this.activecontract = data.ContractId;
			this.clientid = data.ClientId;
			this.businessaccountname = data.CompanyName;
			this.clientbusinessdetailid = data.ClientBusinessDetailId;
			this.clientbusinessaccountid = data.ClientBusinessAccountId;
			this.disableclientselection = true;
		}
	},
	resetform() {
		this.filename = "";
		this.val = 0;
		this.progress = 0;
		this.client = null;
		this.clientid = '';
		this.businessaccountname = '';
		this.clientbusinessdetailid = '';
		this.clientbusinessaccountid = '';
		this.SKUData = [];
		this.SKUlist = [];
		this.ClientUOM = "";
		this.activecontract = "";
		this.totalRecords = 0;
		this.successRecords = 0;
		this.failedRecords = {};
		this.showresult = false;
		this.disabled = false;
		this.FailedResultModal = false;
		this.disableclientselection = false;
		this.compNameArr = [];
		this.uomArr = [];
		this.manifestMethods = [];
		this.boxtypelist = [];
		this.clientFileType = 3;
		this.showuploadresult = false;
		this.uploadResultData = [];
		this.importResultData = [];
		this.showimportbutton = false;
		this.showimportresult = false;
		this.batchsizeforimport = 0;
		this.validrecordsforimport = 0;
		this.fileid = 0;
		this.file = null;
		this.stepOne = false;
		this.stepTwo = false;
		this.stepThree = false;
		this.progressarr = ['stop', 'stop', 'stop', 'stop'];
		this.totaldata = 0;
		this.validateddata = 0;
		this.validdateddatalist = [];
		this.limit = 10;
		this.showprogress = false;
		this.offset = 0
		this.$validator.reset();
		this.isEditing = false;
		this.showSpinner = false;
		this.$refs.files.value=null;
		this.clientErr = false;
		this.uploadedFileData = [];
		this.totalUploadRecords=0;
		this.uploadsuccessRecords=0;
		this.uploadfailedRecords={};
		this.showViewUploadResult=false;
		this.showviewuploadresult=false;
		this.showError=false;
	},
	submitFile() {
		try {
			this.$validator.validateAll("uploadform").then((result) => {
				if (result) {
					this.startUpload();
				}
			}).catch(() => {
				console.log('errors exist');
				return false;
			});
			
		} catch (error) {
			console.log(error);
		}
	},
	async startUpload() {
		try {
			this.disabled = true;
			this.$set(this.progressarr, 0 , 'start')
			this.isEditing= true;
			this.showSpinner= true;
			this.stepOne = await this.uploadFile(this.file)
			// this.stepOne = true
			// this.totaldata = 15
			// this.fileid = 15
			if (this.stepOne) {
				let result;
				this.$set(this.progressarr, 0 , 'complete')
				this.$set(this.progressarr, 1 , 'start')
				result = await this.validate(this.fileid);

				let tempData = this.groupBy(this.validdateddatalist, "status");
				this.totalRecords = this.totaldata;
				if (tempData[1]) {
					this.successRecords = tempData[1];
					this.validrecordsforimport = tempData[1].length;
				}
				if (tempData[0]) {
					this.failedRecords = tempData[0];
				}
				if (this.successRecords.length > 0) {
					this.$alert("File uploaded successfully. Please import data.", "", "success");
				} else {
					this.$alert("No valid record found. Please correct data and upload again.", "", "error");
				}
				this.showresult = true;
				this.stepTwo = true;
				this.$set(this.progressarr, 1 , 'complete')
				this.showSpinner = false
			}
		} catch (error) {
			console.log(error);
		}
	},
	async getCustomTableEvent(event){
		if(event.actionType == 'view'){
			this.isLoading = true
			this.uploadedFileData = [];
			this.totalUploadRecords=0;
			this.uploadsuccessRecords=0;
			this.uploadfailedRecords={};
			this.showViewUploadResult=false;
			this.showviewuploadresult=false;
			let selectedRouteObj  = this.tableArr.filter(function(Items) {
				return Items.id == event.id;
			});
			this.uploadedFileData = [];
			await this.getFileData(selectedRouteObj[0].id)
			this.isLoading = false
	  }
	},
	async getFileUploaddata(){
		try {
		  this.isLoading = true;
		  let inputPayload = {
			"offset": this.offset,
			"limit": this.pageLimit,
			"lastmodifiedby": this.userName
		  }
		  let result = await TripServices.getUploadedFileDetails(inputPayload)
		  if(result.data.code == 200){
			this.tableArr = result.data.data.result.rows;
			this.totalCount = result.data.data.result.count;
			this.tableItems = result.data.data.result.rows.map((el)=>{
			  return {
				'id': el.id,
				'ID': el.id,
				'File Name': el.filename.split("/")[2],
				'File Name Path':el.filenames3,
				'Created Date':el.createddate,
				'Created by': el.createdby,
				'Import Status': el.pushcount>0? 'Successful' : 'Failed'
				}
			 })
		  }else{
			this.totalCount = 0
			this.tableItems = [];
		  }
		  if (this.totalCount < this.pageLimit) {
			this.totalPage = 1
		  } else {
			this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
		  }
		  this.isLoading = false;
		} catch(err){
		  console.log(err);
		  this.isLoading = false;
		}
	  },
	  async getFileData(fileid) {
		try {
			let input = {
				logfileid: fileid,
			}
			let result = await TripServices.getUploadedFileData(input)
			if (result.data.code == 200) {
				this.uploadedFileData.push(...result.data.data)

				let tempData = this.groupBy(this.uploadedFileData, "status");
				this.totalUploadRecords = this.uploadedFileData.length;
				if (tempData[1]) {
					this.uploadsuccessRecords = tempData[1];
				}
				if (tempData[0]) {
					this.uploadfailedRecords = tempData[0];
				}
				this.showViewUploadResult=true;
				return result.data.data;
			} else {

			}
		} catch (err) {
			console.log(err);
		}
	},
	openUploadViewResultData(type) {
		console.log(type);
		this.showviewuploadresult = true;
		this.viewuploadResultData = null;
		if (type == 'valid') {
			this.viewuploadResultData = this.uploadsuccessRecords;
			this.showimportresult = false;
			if (this.successRecords.length > 0 || this.importResultData.length != this.successRecords.length) {
				
			}
		} else if (type == 'invalid') {
			this.viewuploadResultData = this.uploadfailedRecords;
		}
	},
}
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/Autoallocation/uploadrequestedroute/uploadrequestedroute.component.js